import React, { useState } from "react";

const IsokineticTesting = ({ stepData,onSkip, onSubmit }: any) => {

  const assessId = stepData.assessment_id;
  const stepId = stepData.current_step;
  const schema = stepData.ui_schema;
  const config = schema.config;

  // ✅ Active speed (like activeJoint)
  const [activeSpeed, setActiveSpeed] = useState(
    config.speeds[0]
  );

  // ✅ values: speed -> parameterId -> value
  const [values, setValues] = useState<any>({});

  const handleChange = (
    speed: string,
    paramId: string,
    value: any
  ) => {
    setValues((prev: any) => ({
      ...prev,
      [speed]: {
        ...prev[speed],
        [paramId]: value,
      },
    }));
  };

  // ✅ Payload
  const handleSubmit = (endpoint: string) => {
    const payload: any[] = [];

    Object.keys(values).forEach((speed) => {
      Object.keys(values[speed]).forEach((paramId) => {
        payload.push({
          // speed,
          parameter: paramId,
          percentage_value: values[speed][paramId],
        });
      });
    });

    onSubmit(endpoint, payload);
  };

  return (
    <div>
      <h6>{schema.title}</h6>

      <div className="row">
        
        {/* ✅ LEFT: SPEED LIST (like joints) */}
        <div className="col-4">
          <ul className="list-group">
            {config.speeds.map((speed: string) => (
              <li
                key={speed}
                className={`list-group-item ${
                  activeSpeed === speed ? "active" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveSpeed(speed)}
              >
                {speed}
              </li>
            ))}
          </ul>
        </div>

        {/* ✅ RIGHT: PARAMETERS TABLE */}
        <div className="col-8">
          <table className="table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Value ({config.unit})</th>
              </tr>
            </thead>

            <tbody>
              {(config.parameters[activeSpeed] || []).map(
                (param: any) => (
                  <tr key={param.id}>
                    <td>{param.text}</td>

                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          values[activeSpeed]?.[param.id] || ""
                        }
                        onChange={(e) =>
                          handleChange(
                            activeSpeed,
                            param.id,
                            e.target.value
                          )
                        }
                      />
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ✅ Buttons */}
      <div className="d-flex justify-content-end mt-3">
        {schema.buttons.map((btn: any, i: number) => {
          if (btn.action === "SUBMIT_DATA") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-primary"
                onClick={() => handleSubmit(btn.endpoint)}
              >
                {btn.label}
              </button>
            );
          }

          if (btn.action === "SUBMIT_EMPTY") {
            return (
              <button
                key={i}
                type="button"
                className="btn btn-secondary me-2"
                // onClick={() => onSubmit(btn.endpoint, [])}
                onClick={() => onSkip(assessId,stepId)}
              >
                {btn.label}
              </button>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default IsokineticTesting;